import React from 'react';
import { NavLink } from 'react-router-dom';
import { Activity, Server, UserPlus, Users } from 'lucide-react';

const tabs = [
	{
		id: 'clients',
		name: 'Client Overview',
		icon: Users,
		path: '/dashboard/clients',
	},
	{
		id: 'integration-health',
		name: 'Integration Health',
		icon: Activity,
		path: '/dashboard/integration-health',
	},
	{
		id: 'system-status',
		name: 'System Status',
		icon: Server,
		path: '/dashboard/system-status',
	},
	{
		id: 'user-management',
		name: 'User Management',
		icon: UserPlus,
		path: '/dashboard/user-management',
	},
];

export const NavigationTabs: React.FC = () => {
	return (
		<div className="bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="border-b border-gray-200">
					<nav className="-mb-px flex space-x-8 overflow-x-auto">
						{tabs.map((tab) => (
							<NavLink
								key={tab.id}
								to={tab.path}
								className={({ isActive }) =>
									`${
										isActive
											? 'border-blue-500 text-blue-600'
											: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
									} whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center`
								}>
								<tab.icon className="h-4 w-4 mr-2" />
								{tab.name}
							</NavLink>
						))}
					</nav>
				</div>
			</div>
		</div>
	);
};
